'use es6';

import I18n from 'I18n';
import { byName as TemplateTypes } from 'ContentUtils/constants/TemplateTypes';
import ImmutableModel from 'DesignData/models/ImmutableModel';
import { HUBL_CSS, HUBL_JS, HUBL_HTML, JSON as TEMPLATE_FILE_TYPE_JSON, TXT, JS, CSS as TEMPLATE_FILE_TYPE_CSS } from 'DesignData/constants/TemplateFileTypes';
import { PRIMARY_CSS_PATH } from 'DesignData/constants/PrimaryCss';
import PortalCopyTypes from 'DesignData/enums/PortalCopyTypes';
/**
 * Wrapper class of Template data.
 * Intended for reflection and helper methods.
 */

export default class Template extends ImmutableModel {
  /**
   * @constructor
   */
  constructor(props) {
    const path = props.path.toLowerCase();
    const isBuiltin = /^hubspot_default/.test(path) || /^hubspot\/(js|css)\/classic/.test(path) || /^hubspot\/styles/.test(path);
    return super(Object.assign({}, props, {
      isBuiltin
    }));
  }

  getFileType() {
    const {
      templateType
    } = this;

    switch (templateType) {
      case TemplateTypes.css.id:
        return HUBL_CSS;

      case TemplateTypes.js.id:
        return HUBL_JS;

      default:
        {
          // Try to determine type from file extension if present.
          const match = this.path.match(/\.([a-z0-9_-]+)$/i);
          const extension = match && match[1] && match[1].toLowerCase();

          switch (extension) {
            case 'css':
            case 'gss':
            case 'sass':
            case 'scss':
            case 'less':
              return HUBL_CSS;

            case 'html':
            case 'htm':
            case 'xhtml':
            case 'xml':
              return HUBL_HTML;

            case 'js':
              return HUBL_JS;

            case 'json':
              return TEMPLATE_FILE_TYPE_JSON;

            default:
              return templateType !== TemplateTypes.unmapped.id ? HUBL_HTML : TXT;
          }
        }
    }
  }

  isPrimaryCssFile() {
    return this.path === PRIMARY_CSS_PATH;
  }

  isCssOrJs() {
    const fileType = this.getFileType();

    switch (fileType) {
      case HUBL_CSS:
      case HUBL_JS:
      case TEMPLATE_FILE_TYPE_CSS:
      case JS:
      case TEMPLATE_FILE_TYPE_JSON:
        return true;

      default:
        return false;
    }
  }

  getPortalCopyType() {
    return PortalCopyTypes.EXTENSION_RESOURCE;
  }

  getLabel() {
    if (this.isPrimaryCssFile()) {
      return I18n.text('designEditors.codeEditor.tabLabels.primaryCss');
    }

    if (this.label) {
      return this.label;
    }

    if (this.path) {
      return this.path.split('/').pop();
    }

    return I18n.text('designEditors.codeEditor.tabLabels.generic');
  }

}